module.exports = __webpack_public_path__ + "static/media/16UNODC32.57eb2ee2.jpg";